<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
            <v-card v-if="$store.getters.getLanguageList">     
                <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
                <div v-if="getCheckAnswerEvent">{{checkAnswer('user')}}</div>
                <div v-if="needInit">{{initData()}}</div> 
                <v-card-title></v-card-title>
                    <v-card-text>
                        <div v-if="myContent">
                            <div v-html="myContent.content">
                            </div>
                            <v-text-field v-model="myAnswer" filled color="styleObject.color" @change="styleObject.color = 'black'; feedback = '';">                    
                            </v-text-field>                  
                            <p v-if="feedback" v-bind:style="styleObject">{{feedback}}</p>  
                        </div>
                    </v-card-text>
                    <v-card-actions>
                       
                    </v-card-actions>
            </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'

export default {   
    data() {
        return {
                myContent:  {
                    content: 'loading...',
                    help: 'loading...',
                    answer_list : [{
                        answer : 'loading...',
                        feedback: 'loading...'
                    }]
                },
                myAnswer : null,
                myGlobals: null,
                feedback: null,
                showMyHelp: false,
                needInit : false,
                styleObject: {
                    color: 'black',
                }

        }
    },
    computed: 
        mapGetters([
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    'getTryAgainEvent'
                    ])
    ,    
    props: { 
        dcontent: Object
    },
    methods: {
        initData() {
            this.needInit = false  
            this.$store.commit('setFeedback', null)               
            this.myContent = (this.dcontent.data.content)
            this.myGlobals = (this.dcontent.data.globals)
            this.rating = 0
        },
        checkAnswer(owner) {
            this.$store.commit('setCheckAnswerEvent', false)
            this.$store.commit('setTryAgainEvent',true)
            
            for(var i = 0; i < this.myGlobals.ratings.length; i++) {
                if (this.myAnswer == this.myContent.answer_list[i].answer) {
                    this.feedback = this.myContent.answer_list[i].feedback
                 //   this.$store.commit('setTaskRating',this.myGlobals.ratings[i])
                    this.$store.commit('setAnswer',this.describeAnswer(owner,this.myGlobals.ratings[i],i))
                    this.$store.commit('setCheckRatingEvent',true)
                    if (this.myGlobals.ratings[i] == 100) {
                        if (this.myContent.answer_list[i].feedback == '') this.feedback = 'Correct!'
                        this.styleObject.color = 'green'
                        return
                    }
                  //  this.$store.commit('setTryAgainEvent',true)
                    if (this.myGlobals.ratings[i] < 100 && this.myGlobals.ratings[i] > 0) this.styleObject.color = 'orange'

                    return
                }
            }           
        //    this.$store.commit('setTaskRating', 0)
            this.$store.commit('setAnswer',this.describeAnswer(owner,0),0)
          //  this.$store.commit('setTryAgainEvent',true)
            this.$store.commit('setCheckRatingEvent',true)
            this.styleObject.color = 'red'
            this.feedback = "Sorry, bad answer."
        },
        showAnswer() {
            this.$store.commit('setShowAnswerEvent', false)
            for(var i = 0; i < this.myGlobals.ratings.length; i++) {
                if (this.myGlobals.ratings[i] == 100) {
                    this.myAnswer = this.myContent.answer_list[i].answer
                    this.feedback = this.myContent.answer_list[i].feedback
                    this.checkAnswer('system')
                    return
                }
            }
            
        },
        describeAnswer(user,score, index) {
            return {
                solver: user,
                type: 2,
                answer: this.myAnswer,
                answer_index: [index],
                rating: score
            }
        }
    },
    mounted() {
        this.needInit = true
    }
}
</script>

